module.exports = __webpack_public_path__ + "static/media/i3.6f529fdd.png";